import i18next from 'i18next'
import React from 'react'
import { any, async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { JqueryState } from '../jquery/jqueryState'
import { MailPlusFormLayout } from './mailPlusFormLayout'
import { mailPlusFormPageStateUpdaters, MailPlusFormState } from './mailPlusFormState'
import { FormResponse } from '../../backendApi/generated'

const loading = () =>
  fromJSX(() => (
    <div className="loader__content container--s gutter--m spacing--m">
      <p className="loader__text">{i18next.t('global:Loading')}</p>
    </div>
  ))

export const mailPlusFormWidget = (
  props: MailPlusFormState,
  jquery: JqueryState,
  onInvalidForm: () => JSX.Element,
  hasContainer: boolean
): Widget<Updater<MailPlusFormState>> =>
  jquery.jquery.kind === 'loaded' && jquery.jqueryValidate.kind === 'loaded'
    ? any([
        async<FormResponse>(props.result).map(mailPlusFormPageStateUpdaters.updateSearchResult),
        props.result.kind === 'loading'
          ? loading().never()
          : fromJSX(() => (
              <MailPlusFormLayout {...props} onInvalidForm={onInvalidForm} hasContainer={hasContainer} />
            ))
      ])
    : loading().never()
